export default __webpack_public_path__ + "static/media/addCircle.2b97ac43.svg";